import { UPDATEMEMBER_FAIL, UPDATEMEMBER_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateMemberReducer;
